




















import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {
    ListMessages
  }
})
export default class ShippingQuoteAddressMenuButton extends BaseComponent {
  @Prop()
  public item;
}
